import { Link } from "react-router-dom";

/**
 * Big, high-visibility "back to the main Milk2Income sales page" button used
 * across all affiliate pages. Resolves to `/` which, in production, serves the
 * main /milk2cash landing (deployed under the same origin).
 *
 * `variant='dark'` is for use on the dark admin dashboard; default is the
 * cream-page look used on the affiliate pages.
 */
export default function BackToSiteBadge({ variant = "light", label = "Back to Milk2Income" }) {
  const dark = variant === "dark";
  return (
    <Link
      to="/"
      className={`inline-flex items-center gap-3 px-5 py-3 rounded-full transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5 ${
        dark
          ? "bg-[var(--cream)] text-[var(--ink)] hover:bg-white"
          : "bg-[var(--ink)] text-[var(--cream)] hover:bg-[#1a2e24]"
      }`}
      data-testid="back-to-site-badge"
      aria-label={label}
    >
      {/* Milk-drop icon (same mark used in the main site) */}
      <span
        className={`w-10 h-10 rounded-full flex items-center justify-center ${
          dark ? "bg-[var(--ink)]" : "bg-[var(--marigold)]"
        }`}
        aria-hidden
      >
        <svg viewBox="0 0 64 64" width="22" height="22">
          <path
            d="M32 10c6.5 9 13 16.5 13 24a13 13 0 1 1-26 0c0-7.5 6.5-15 13-24z"
            fill={dark ? "#FDFBF7" : "#FDFBF7"}
          />
          <circle cx="32" cy="38" r="4.5" fill="#E65C00" />
        </svg>
      </span>
      <span className="pr-1">
        <span className="block font-display text-base leading-tight">
          {label}
        </span>
        <span
          className={`block text-[10px] font-mono-caption tracking-[0.22em] uppercase ${
            dark ? "text-[var(--muted)]" : "text-[var(--cream)]/60"
          }`}
        >
          Buy the $3 ebook
        </span>
      </span>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
          d="M5 12h14M13 5l7 7-7 7"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </Link>
  );
}
